<div class="popup-container tlms-popup">
    <header>
        <div class="header" style="display:block"> {{heading}}</div>
        <button class="close" style="top:-3px" (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </header>
    <div class="body" style="padding: 16px 24px 16px 24px;">
        <div class="form-row">
            <div class="form-col">
                <label class="catlabel">
                    From Period<span style="color:#ff0000">*</span>
                </label>
                <select [(ngModel)]="selected_from_period_id" [ngModelOptions]="{standalone: true}" class="category"
                    style="width: 100%;">
                    <option *ngFor="let fromPeriod of fromPeriodList" [value]="fromPeriod.periodId">
                        {{ fromPeriod.period }}
                    </option>
                </select>
            </div>
        </div>
        <div class="form-row">
            <div class="form-col">
                <label class="catlabel">
                    To Period<span style="color:#ff0000">*</span>
                </label>
                <select [(ngModel)]="selected_period_id" [ngModelOptions]="{standalone: true}" class="category"
                    style="width: 100%;">
                    <option *ngFor="let toPeriod of toPeriodList" [value]="toPeriod.periodId">
                        {{ toPeriod.period }}
                    </option>
                </select>
            </div>
        </div>
    </div>
    <label *ngIf="enableError" class="errormsg"> {{errormsg}} </label>
    <div class="cfooter d-flex justify-content-between align-items-center popup-footer">
        <button (click)="onNoClick()" class="mCancel">CANCEL</button>
        <button mat-raised-button class="black-btn" style="display: inline;" (click)="saveClick()">SUBMIT</button>
    </div>
</div>